module.exports = __webpack_public_path__ + "img/ps-1.db9f3560.jpg";